export default __webpack_public_path__ + "static/07-395938eb7845457a8bc159e7ac60bae1.jpg";